import { Badge } from "@fluentui/react-components";
import type { TicketPriority } from "../api/tickets";

const colorMap: Record<TicketPriority, "subtle" | "informative" | "warning" | "danger"> = {
  Low: "subtle",
  Medium: "informative",
  High: "warning",
  Critical: "danger",
};

export default function PriorityBadge({ priority }: { priority: TicketPriority }) {
  return (
    <Badge appearance="outline" color={colorMap[priority] ?? "subtle"} size="small">
      {priority}
    </Badge>
  );
}
